
import React, { useState, useEffect } from 'react';
import axios from 'axios';

function SavedEventsPage() {
  const [savedEvents, setSavedEvents] = useState([]);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = JSON.parse(atob(token.split('.')[1]));
        setUser(decoded);
        const userId = decoded?.[
          "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
        ];
        if (userId) {
          fetchUserSavedEvents(userId);
        }
      } catch (error) {
        console.error("Error decoding token:", error);
        setUser(null);
      }
    }
  }, []);

  const fetchUserSavedEvents = (userId) => {
    axios.get(`https://localhost:7136/api/savedevents/user/${userId}`)
      .then((response) => {
        setSavedEvents(response.data);
      })
      .catch((error) => {
        console.error("Error fetching user's saved events:", error);
      });
  };

 

     

  const handleReserve = async (eventId) => {
    const token = localStorage.getItem('token');
    const userId = localStorage.getItem('userId');

    if (!token || !user) {
      console.log("يجب تسجيل الدخول للحجز.");
      return;
    }
    // const userId = user?.[
    //   "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
    // ];

    try {
      const response = await axios.post('https://localhost:7136/api/registrations/register', { userId, eventId });
      if (response.status === 200) {
        alert(response.data || "تم حجز تذكرتك بنجاح!"); // تم تعديل عرض الرسالة
        // يمكنك هنا تحديث حالة عدد التذاكر المتبقية إذا لزم الأمر
      } else if (response.status === 400 || response.status === 404 || response.status === 409) {
        alert(`حدث خطأ أثناء الحجز: ${response.data?.Message || "يرجى المحاولة مرة أخرى."}`);
      } else {
        alert("حدث خطأ غير متوقع أثناء الحجز. يرجى المحاولة مرة أخرى لاحقًا.");
      }
    } catch (error) {
      console.error("Error registering for event:", error);
      alert("حدث خطأ غير متوقع أثناء الحجز. يرجى المحاولة مرة أخرى لاحقًا.");
      if (error.response) {
        console.log(error.response.data); // عرض تفاصيل الخطأ من الواجهة الخلفية
      }
    }
  };

  return (
    
<div
      className="min-h-screen bg-cover bg-center p-8"
      style={{ backgroundImage: `url('./images/photo16.jpg')` }}
    > 
          <div className="container mx-auto">
          <h1 className="text-3xl font-bold mb-4 text-blue-500">الفعاليات المحفوظة</h1>
          {savedEvents.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {savedEvents.map((event) => (
              <div
                key={event.eventId}
                className="bg-white p-6 rounded-2xl shadow-xl transition-transform transform duration-300 hover:scale-105 hover:shadow-2xl hover:-translate-y-2 cursor-pointer"
              >

                <h3 className="text-2xl font-bold text-gray-800 mb-2 font-custom">{event.title}</h3>
                <p className="text-gray-600 mb-2 font-custom">{event.description}</p>
                <p className="text-gray-800 font-custom">Organizer Name: {event.organizerName}</p>
                <p className="text-gray-800 font-custom">Venue: {event.venue}</p>
                <p className="text-gray-800 font-custom">
                  Event Date: {new Date(event.eventDatetime).toLocaleDateString()}
                </p>
                <p className="text-gray-800 font-custom">Ticket Price: {event.ticketPrice} EGP</p>
                <p className="text-gray-800 font-custom">Number of Tickets Left: {event.numberofTicketsLeft}</p>
                <p className="text-gray-800 font-custom">Number of Participants Submitted: {event.numberofParticipantsSubmitted}</p>

                <button
                  onClick={() => handleReserve(event.eventId)}
                  className="mt-4 w-full bg-purple-600 hover:bg-purple-700 text-white font-bold py-2 px-4 rounded-xl transition"
                >
                  احجز تذكرتك
                </button>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-500">لا يوجد لديك فعاليات محفوظة حاليًا.</p>
        )}
      </div>
    </div>
  );
}

export default SavedEventsPage;